import { useThemeUI } from 'theme-ui'
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon'

const StarRating = ({ starsNumber = 5, value = 2.5, EndIcon, variant }) => {
  const theme = useThemeUI().theme
  const getVariant = element => `elements.starRating.${variant ? variant + '.' + element : element}`

  let displayedValue = value
  try {
    displayedValue = value.toFixed(1)
  } catch {
    console.error('Could not parse value')
  }

  const StarIcon = variant => <DynamicSparkIcon glyph={`star-${variant}`} size={18} />

  const stars = []
  for (let counter = 1; counter <= starsNumber; counter++) {
    variant = ''

    // if value is x.5 icon is half filled star, outlined otherwise
    if (counter > value) variant = counter - 0.5 == displayedValue ? 'half-filled' : 'outlined'
    else variant = 'filled'

    stars.push(StarIcon(variant))
  }

  return (
    <div sx={{ display: 'flex', p: 'xxs', alignItems: 'center', variant: getVariant('base') }}>
      <div
        sx={{
          fontSize: 'lg',
          color: theme.compounds.card?.scoreColor,
          fontWeight: 'bold',
          mr: 'xs',
          variant: getVariant('value'),
        }}
      >
        {displayedValue}
      </div>
      <For each='star' of={stars} index='key'>
        <div sx={{ mr: 'xs', variant: getVariant('star') }} key={key}>
          {star}
        </div>
      </For>
      <If condition={EndIcon}>{EndIcon}</If>
    </div>
  )
}

export default StarRating
